/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/11/22, 8:23 AM
 *
 */

import ProfileImageModal from 'features/members/components/modal/ProfileImageModal/ProfileImageModal';

export default ProfileImageModal;
